import { takeLatest, put, call } from 'redux-saga/effects';
import { axiosInstance } from '../../utils';

import {
  MODAL_CLOSE,
  EMAIL_SUBSCRIPTION_REQUEST,
  EMAIL_SUBSCRIPTION_SUCCESS,
  EMAIL_SUBSCRIPTION_FAILURE,
  EMAIL_SUBSCRIPTION_TO_SPOT_OPEN_ALERT_REQUEST,
  EMAIL_SUBSCRIPTION_TO_SPOT_OPEN_ALERT_SUCCESS,
  EMAIL_SUBSCRIPTION_TO_SPOT_OPEN_ALERT_FAILURE,
} from "../types";

function* emailSubscriptionSaga({ payload }) {
  try {
    yield call(axiosInstance.post, 'newsletter/subscribe', { email: payload });
    yield put({ type: EMAIL_SUBSCRIPTION_SUCCESS });
  } catch (error) {
    yield put({ type: EMAIL_SUBSCRIPTION_FAILURE, payload: 'Something went wrong' });
  }
}

function* emailSubscriptionToSpotOpenAlertSaga({ payload }) {
  const {
    email,
    date,
    productId,
  } = payload;
  try {
    yield call(axiosInstance.post, '/products/waiting', { email, date, productId });

    yield put({ type: MODAL_CLOSE });
    yield put({ type: EMAIL_SUBSCRIPTION_TO_SPOT_OPEN_ALERT_SUCCESS });
  } catch (error) {
    yield put({ type: EMAIL_SUBSCRIPTION_TO_SPOT_OPEN_ALERT_FAILURE, payload: 'Something went wrong' });
  }
}

export default function* saga() {
  yield takeLatest(EMAIL_SUBSCRIPTION_REQUEST, emailSubscriptionSaga);
  yield takeLatest(EMAIL_SUBSCRIPTION_TO_SPOT_OPEN_ALERT_REQUEST, emailSubscriptionToSpotOpenAlertSaga);
}
